<template>
    <div class="mx-3">
        <div class="flex justify-between">
            <strong>Selecciona tipo de filtro</strong>
            <app-button circle icon @click="redirectToCreating">
                ➕
            </app-button>
        </div>
        <div class="w-full mt-3 flex justify-around">
            <custom-radio
                v-for="(value, key) in $data.$filtersTypes"
                :key="key"
                v-model="filterType"
                :val="key"
            >
                {{ value }}
            </custom-radio>
        </div>

        <div class="mt-5 mb-2">
            <span v-show="errorString" class="text-danger">
                {{ errorString }}
            </span>
            <div v-if="filterType === 'phone'" class="mt-5 flex items-end">
                <custom-input
                    id="phone"
                    v-model="phone"
                    type="text"
                    name="phone"
                    label="Celular"
                    class="w-full mr-2"
                    aria-label="Celular"
                    :disabled="isLoading"
                    :error="
                        introPhone && !isValidPhone
                            ? 'Ingrese un celular válido'
                            : ''
                    "
                    @focus="onFocus"
                    @input="clearPhone"
                    @blur="onBlurPhone"
                    @enter="onClickPhone"
                >
                    <template #icon> ✉ </template>
                </custom-input>
                <app-button
                    circle
                    icon
                    :loading="isLoading"
                    @click="onClickPhone"
                >
                    🔎
                </app-button>
            </div>

            <div v-if="filterType === 'email'" class="mt-5 flex items-end">
                <custom-input
                    id="email"
                    v-model="email"
                    type="text"
                    name="email"
                    label="Correo"
                    class="w-full mr-2"
                    aria-label="Email"
                    :disabled="isLoading"
                    :error="
                        introEmail && !isValidEmail
                            ? 'Ingrese correo válido'
                            : ''
                    "
                    @focus="onFocus"
                    @blur="onBlurEmail"
                    @input="lowerCaseEmail"
                    @enter="onClickEmail"
                >
                    <template #icon> ✉ </template>
                </custom-input>
                <app-button
                    circle
                    icon
                    :loading="isLoading"
                    @click="onClickEmail"
                >
                    🔎
                </app-button>
            </div>

            <div v-if="filterType === 'fullName'" class="mt-5 flex items-end">
                <custom-input
                    id="fullName"
                    v-model="fullName"
                    type="text"
                    name="fullName"
                    label="Nombre"
                    class="w-full mr-2"
                    aria-label="Nombre"
                    :disabled="isLoading"
                    :error="
                        introFullName && !isValidFullName
                            ? 'Ingrese un nombre válido'
                            : ''
                    "
                    @focus="onFocus"
                    @blur="onBlurFullName"
                    @enter="onClickFullName"
                >
                    <template #icon> 🧑 </template>
                </custom-input>
                <app-button
                    circle
                    icon
                    :loading="isLoading"
                    @click="onClickFullName"
                >
                    🔎
                </app-button>
            </div>

            <div
                v-if="filterType === 'identificationNumber'"
                class="mt-5 flex items-end"
            >
                <custom-input
                    id="document"
                    v-model="identificationNumber"
                    type="text"
                    name="document"
                    label="Número de documento"
                    class="w-full mr-2"
                    aria-label="Document"
                    :disabled="isLoading"
                    :error="
                        introIdentificationNumber &&
                        !isValidIdentificationNumber
                            ? 'Ingrese un documento válido'
                            : ''
                    "
                    @blur="onBlurIdentificationNumber"
                    @focus="onFocus"
                    @enter="onClickIdentification"
                    @input="isLoaded = false"
                >
                    <template #icon> 🖋 </template>
                </custom-input>
                <app-button
                    circle
                    icon
                    :loading="isLoading"
                    @click="onClickIdentification"
                >
                    🔎
                </app-button>
            </div>

            <div v-if="filterType === 'new'">
                <span>
                    Crea el usuario haciendo click en el siguiente botón. NO se
                    perderá el registro, te abrirá una nueva pestaña crea el
                    usuario y regresa a esta pestaña para continuar con el
                    registro.
                </span>
                <div class="mt-2 flex justify-center">
                    <app-button @click="redirectToCreating">
                        Redigir a página de creación
                    </app-button>
                </div>
            </div>
        </div>
        <div v-if="isLoaded">
            <span class="mb-2">
                Resultados de búsqueda {{ itemsFound.length }}
            </span>

            <user-table-items
                v-for="item in itemsFound"
                :key="item.id"
                :user="item"
                :slug="
                    isCustomer
                        ? `/app/customers/detail/${item.id}`
                        : `/app/users/detail/${item.id}`
                "
                @click="selectUser"
            />
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

import {
    emailSimpleRegex,
    identificationNumberRegex,
    nameRegex,
    stringNumberRegex
} from "@/common/lib/regex";

import CustomInput from "@/components/utils/CustomInput.vue";

import UserTableItems from "./UserTableItems.vue";

export default {
    name: "SearchUser",
    components: { UserTableItems, CustomInput },
    model: {
        event: "input",
        prop: "itemCurrent"
    },
    props: {
        isCustomer: {
            type: Boolean,
            default: () => false, // default customer
            required: false
        },
        itemCurrent: {
            type: Object,
            default: () => ({
                email: "",
                firstName: "",
                id: 0,
                identificationNumber: "",
                identificationType: "cc",
                lastName: "",
                phone: "",
                updatedAt: ""
            }),
            required: false
        }
    },
    emits: ["input", "blur", "focus"],
    data: () => ({
        $filtersTypes: {
            phone: "Celular",
            fullName: "Nombre",
            email: "Correo",
            identificationNumber: "Identificación"
        },
        filterType: "phone",
        phone: "",
        email: "",
        identificationNumber: "",
        errorString: "",
        fullName: "",
        lastName: "",
        isValidEmail: false,
        introPhone: false,
        introEmail: false,
        introIdentificationNumber: false,
        introFullName: false,
        isLoading: false,
        isLoaded: false,
        itemsFound: []
    }),
    computed: {
        isValidIdentificationNumber() {
            return identificationNumberRegex.test(this.identificationNumber);
        },
        isValidFullName() {
            return this.fullName && nameRegex.test(this.fullName);
        },
        isValidPhone() {
            return stringNumberRegex.test(this.phone);
        }
    },
    watch: {
        filterType() {
            this.reset();
        }
    },
    methods: {
        ...mapActions("users", ["searchUsers"]),
        ...mapActions("customers", ["searchCustomers"]),
        lowerCaseEmail() {
            this.isLoaded = false;
            this.isValidEmail = emailSimpleRegex.test(this.email);
            this.email = this.email.toLowerCase();
        },
        onClickPhone() {
            this.listItems({ phone: this.phone });
        },
        onClickEmail() {
            this.listItems({ email: this.email });
        },
        onClickFullName() {
            this.listItems({ fullName: this.fullName });
        },
        onClickIdentification() {
            this.listItems({
                identificationNumber: this.identificationNumber
            });
        },
        async listItems(query) {
            this.errorString = "";
            this.isLoading = true;
            this.isLoaded = false;
            try {
                if (this.isCustomer) {
                    this.itemsFound = await this.searchCustomers(query);
                } else {
                    this.itemsFound = await this.searchUsers(query);
                }
            } catch (error) {
                this.errorString = `Error code ${error.statusCode}`;
            } finally {
                this.isLoading = false;
                this.isLoaded = true;
            }
        },
        selectUser(user) {
            this.$emit("change", user);
            this.reset();
        },
        reset() {
            this.introEmail = false;
            this.introIdentificationNumber = false;
            this.introFullName = false;
            this.email = "";
            this.identificationNumber = "";
            this.fullName = "";
        },
        redirectToCreating() {
            window
                .open(
                    this.isCustomer ? "/app/customers/new" : "/app/users/new",
                    "_blank"
                )
                .focus();
        },
        clearPhone() {
            this.phone = this.phone.trim().replace(/\s+/g, "");
        },
        onBlurFullName() {
            this.introName = true;
            this.$emit("fullName");
        },
        onBlurPhone() {
            this.introPhone = true;
            this.$emit("blur");
        },
        onBlurEmail() {
            this.introEmail = true;
            this.email = this.email.trim().replace(/\s+/g, "");
            this.$emit("blur");
        },
        onBlurIdentificationNumber() {
            this.introIdentificationNumber = true;
            this.identificationNumber = this.identificationNumber
                .trim()
                .replace(/\s+/g, "");
            this.$emit("blur");
        },
        onFocus() {
            this.$emit("focus");
        }
    }
};
</script>
